var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-special-data-grid" },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px", "margin-bottom": "5px" },
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.finalRowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit,
              expression: "isEdit"
            }
          ],
          staticStyle: { width: "100%" }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "Add", type: "primary" },
                  on: { click: _vm.add }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "Delete", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }